import * as SentrySDK from '@sentry/react';

SentrySDK.init({
  dsn: 'https://59df416c74bbd7ae225a7b372516d294@o4511584348143616.ingest.us.sentry.io/4511584393691136',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.05,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection captured',
    /^Loading chunk \d+ failed/,
  ],
});

export const Sentry = SentrySDK;
